export default "__VITE_ASSET__DytswcMO__"